import React, { useEffect, useState, useRef } from "react"
import clsx from "clsx"

import Input from "./Input"
import classes from "./ChipInput.module.scss"

const ChipInput = props => {
  const {
    values,
    onAdd,
    label,
    maxValues = -1,
    error,
    className,
    type = "text",
    onDelete,
    disabled = false,
    placeholder = ""
  } = props

  const [inputText, setInputText] = useState("")
  const [focused, setFocused] = useState(false)

  const textRef = useRef(null)
  const inputRef = useRef(null)

  const handleChangeText = async (e) => {
    const value = e.target.value

    setInputText(value)
  }

  const handleKeyPress = (e) => {
    const value = inputText

    if (
      e.key !== "Enter" ||
      !value ||
      values.includes(value) ||
      maxValues === values.length ||
      (type === "number" && isNaN(value))
    ) return

    inputRef.current.style.width = "5px"

    onAdd(inputText)
    setInputText("")
  }

  const handleFocus = () => {
    !disabled && inputRef.current.focus()
  }

  const handleRemoveChip = (value) => {
    onDelete(value)
  }

  useEffect(() => {
    inputRef.current.style.width = inputText !== "" ?
      `${textRef.current.offsetWidth}px` : "5px"

  }, [inputText])

  const showPlaceholder =
    !inputText &&
    values.length === 0
  return (
    <div className={className}>
      {
        !!label &&
        <label className={classes["label"]}>
          {label}
        </label>
      }
      <div
        className={clsx(classes["container"],
          focused && classes["focused"],
          !!error && classes["container-error"],
          !!error && focused && classes["focused-error"],
          disabled && classes["disabled"]
        )}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        onClick={handleFocus}
      >
        <div className={classes["chip-container"]}>
          {values.map((value, i) => (
            <div
              key={i}
              className={classes["chip"]}
            >
              <div className={classes["chip-text"]}>
                {value}
              </div>
              {
                !disabled &&
                <div
                  onClick={() => handleRemoveChip(value)}
                  className={classes["remove-chip"]}
                >
                  &times;
                </div>
              }
            </div>
          ))}
          <div
            ref={textRef}
            className={classes["text"]}
          >
            {inputText}
          </div>
          <Input
            type={type}
            className={classes["input"]}
            ref={inputRef}
            disabled={disabled}
            value={inputText}
            onChange={(e) => handleChangeText(e)}
            onKeyPress={handleKeyPress}
          />
        </div>
        {
          showPlaceholder &&
          <div className={classes["placeholder"]}>
            {placeholder}
          </div>
        }
      </div>
      {
        !!error &&
        <div className={classes["error"]}>
          {error}
        </div>
      }
    </div>
  )
}

export default ChipInput